import { render, staticRenderFns } from "./CustomPage.vue?vue&type=template&id=57ff30ae&scoped=true&"
import script from "./CustomPage.vue?vue&type=script&lang=js&"
export * from "./CustomPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomPage.vue?vue&type=style&index=0&id=57ff30ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff30ae",
  null
  
)

export default component.exports